// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-k_fz","catalogByServiceItem__title":"c-k_fA"};